// PowerMeter3Phase Template Styles
// Three-phase power meter modal templates

import { Template01_Dashboard } from './Template01_Dashboard';

export const PowerMeter3PhaseStyles = {
  Template01_Dashboard,
} as const;

export { Template01_Dashboard };
export type { ThreePhaseDevice, ThreePhaseModalProps } from './Template01_Dashboard';
export default Template01_Dashboard;
